import { Box, MenuItem, Tab, Tabs, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";

const tabs = [
  {
    key: "pending",
    label: "Pending",
  },
  {
    key: "confirmed",
    label: "Confirmed",
  },
  {
    key: "return",
    label: "Return",
  },
  {
    key: "cancelled",
    label: "Cancelled",
  },
];

const StyledTabs = styled((props: any) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  background: "#F4F4F4",
  overflow: "auto",
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: "4px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "#6E8C20",
    height: "4px",
  },
});

const StyledTab = styled((props: any) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    display: "flex",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "15px",
    marginRight: theme.spacing(3),
    // minHeight: "60px",
    // padding: "10px 0px",
    "& svg path": {
      stroke: "#323232",
    },
    color: "#323232",
    "&.Mui-selected": {
      color: "#6E8C20",
      fontWeight: 600,

      "& svg path": {
        stroke: "#6E8C20",
      },
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);

const BookingStatusTabs = ({
  tab,
  selection = false,
}: {
  tab: string;
  selection?: boolean;
}) => {
  const navigate = useNavigate();

  if (selection)
    return (
      <TextField
        value={tab}
        select
        size="small"
        onChange={({ target }) => navigate(`/rental?type=${target.value}`)}
      >
        {tabs.map((t: any) => (
          <MenuItem value={t.key}>{t.label}</MenuItem>
        ))}
      </TextField>
    );

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
      }}
    >
      <StyledTabs
        value={tab}
        sx={{
          borderBottom: "1px solid #E2E2E2",
        }}
        onChange={(_: any, v: any) => navigate(`/rental?type=${v}`)}
        scrollButtons={false}
        variant="scrollable"
      >
        {tabs.map((t: any, i: number) => (
          <StyledTab
            label={t.label}
            value={t.key}
            sx={{
              marginRight: {
                md: "20px",
                lg: "20px",
                xl: "20px",
                sm: "5px",
                xs: "5px",
              },
            }}
          />
        ))}
      </StyledTabs>
    </Box>
  );
};

export default BookingStatusTabs;
